/**
 * portalVisibility.js — Helper único para resolver visibilidad y mapeo de tipos
 * de solicitud RRHH a partir de la configuración devuelta por
 * `/api/hr/config` (admin) o `/api/hr/employee-config` (empleado).
 *
 * Reglas:
 *  - `card`          → mostrar tarjeta en dashboard
 *  - `allow_request` → permite seleccionar el tipo al crear una nueva solicitud
 *  - `summary`       → incluir en el resumen superior agregado
 *  - `filter`        → mostrar en filtros "Mis solicitudes"
 *
 * Importante:
 *  - Ocultar la tarjeta NO impide solicitar el tipo (regla del producto).
 *  - Los `value` provienen de `hr_config.request_types[].value` y son la
 *    misma key usada en `portal_visibility`. No hay traducción.
 */

const DEFAULT_FLAGS = { card: true, allow_request: true, summary: true, filter: true };

export function getVisibility(hrConfig, typeValue) {
  const map = hrConfig?.portal_visibility || {};
  const v = map[typeValue];
  if (!v || typeof v !== "object") return { ...DEFAULT_FLAGS };
  return { ...DEFAULT_FLAGS, ...v };
}

/** Todos los tipos activos (requisito previo: t.active). */
function _activeBase(hrConfig) {
  return (hrConfig?.request_types || []).filter((t) => t && t.active);
}

/**
 * Tipos que el empleado puede seleccionar en "Nueva solicitud".
 * Filtro: active && (portal_visibility[type].allow_request !== false).
 * NO depende de `card`.
 */
export function getRequestableTypes(hrConfig) {
  return _activeBase(hrConfig).filter((t) => getVisibility(hrConfig, t.value).allow_request !== false);
}

/** Tipos que se muestran como TARJETAS en el dashboard del Portal Empleado. */
export function getCardVisibleTypes(hrConfig) {
  return _activeBase(hrConfig).filter((t) => getVisibility(hrConfig, t.value).card !== false);
}

/** Tipos que se incluyen en el resumen superior del Portal Empleado. */
export function getSummaryTypes(hrConfig) {
  return _activeBase(hrConfig).filter((t) => getVisibility(hrConfig, t.value).summary !== false);
}

/** Tipos que aparecen en los filtros de "Mis solicitudes". */
export function getFilterTypes(hrConfig) {
  return _activeBase(hrConfig).filter((t) => getVisibility(hrConfig, t.value).filter !== false);
}
